"use client";

import { c as _c } from "react/compiler-runtime";
import { useRouter, useSearchParams } from "next/navigation";
import { useCallback, useMemo } from "react";
import { PROJECT_WIZARD_DEFAULT_SEARCH } from "@/lib/router-search-defaults";
type ProjectWizardSearchParams = {
  search: string;
  document: string;
  location: string[];
  status: string[];
  page: string;
};
function getSearchParamArray(urlSearchParams: URLSearchParams, key: string): string[] {
  const values = urlSearchParams.getAll(key);
  if (values.length > 0) return values;
  const single = urlSearchParams.get(key);
  return single ? single.split(",").filter(Boolean) : [];
}
export function useProjectWizardSearch() {
  const $ = _c(26);
  const urlSearchParams = useSearchParams();
  const router = useRouter();
  let t0;
  if ($[0] !== urlSearchParams) {
    t0 = urlSearchParams.get("search") ?? "";
    $[0] = urlSearchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== urlSearchParams) {
    t1 = urlSearchParams.get("document") ?? "";
    $[2] = urlSearchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== urlSearchParams) {
    t2 = getSearchParamArray(urlSearchParams, "location");
    $[4] = urlSearchParams;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== urlSearchParams) {
    t3 = getSearchParamArray(urlSearchParams, "status");
    $[6] = urlSearchParams;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== urlSearchParams) {
    t4 = urlSearchParams.get("page") ?? "1";
    $[8] = urlSearchParams;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t0 || $[11] !== t1 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = {
      search: t0,
      document: t1,
      location: t2,
      status: t3,
      page: t4
    };
    $[10] = t0;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const searchParams = t5;
  let t6;
  if ($[16] !== router || $[17] !== searchParams || $[18] !== urlSearchParams) {
    t6 = updates => {
      const next = new URLSearchParams(urlSearchParams.toString());
      const merged = {
        search: updates.search ?? searchParams.search,
        document: updates.document ?? searchParams.document,
        location: updates.location ?? searchParams.location,
        status: updates.status ?? searchParams.status,
        page: updates.page ?? searchParams.page
      };
      for (const [key, value] of Object.entries(merged)) {
        next.delete(key);
        if (Array.isArray(value)) {
          for (const v of value) {
            next.append(key, v);
          }
        } else {
          if (value !== null && value !== undefined && value !== "") {
            next.set(key, String(value));
          }
        }
      }
      router.push(`?${next.toString()}`);
    };
    $[16] = router;
    $[17] = searchParams;
    $[18] = urlSearchParams;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  const updateSearch = t6;
  let t7;
  if ($[20] !== router) {
    t7 = () => {
      const next_0 = new URLSearchParams();
      for (const [key_0, value_0] of Object.entries(PROJECT_WIZARD_DEFAULT_SEARCH)) {
        if (Array.isArray(value_0)) {
          for (const v_0 of value_0) {
            next_0.append(key_0, v_0);
          }
        } else {
          if (value_0 !== null && value_0 !== undefined && value_0 !== "") {
            next_0.set(key_0, String(value_0));
          }
        }
      }
      router.push(`?${next_0.toString()}`);
    };
    $[20] = router;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  const resetSearch = t7;
  let t8;
  if ($[22] !== resetSearch || $[23] !== searchParams || $[24] !== updateSearch) {
    t8 = {
      searchParams,
      updateSearch,
      resetSearch
    };
    $[22] = resetSearch;
    $[23] = searchParams;
    $[24] = updateSearch;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
}